import { PureComponent, createRef } from 'react';
import { NavMarker } from 'react-rhumb';
import I18n from 'I18n';
import { PlayerTypes } from 'video-embed/types';
import { DEFAULT_PLAY_BUTTON_COLOR, PLAY_BUTTON_SVG, PlayerStatus } from '../constants';
import SimpleVideoPlayer from './SimpleVideoPlayer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SimplePlayButton = ({
  onClick,
  backgroundColor = DEFAULT_PLAY_BUTTON_COLOR
}) => {
  if (!backgroundColor.startsWith('#')) {
    backgroundColor = `#${backgroundColor}`;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("button", {
      "aria-label": I18n.text('videoPlayer.controls.playVideo'),
      className: "vjs-big-play-button simple-play-button",
      style: {
        backgroundColor
      },
      onClick: onClick,
      dangerouslySetInnerHTML: {
        __html: PLAY_BUTTON_SVG
      }
    })
  );
};
export default class StaticPosterImage extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      imgLoadFailed: false
    };
    this.videoEl = /*#__PURE__*/createRef();
    this.handleLoading = () => {
      this.props.onStatusChange(PlayerStatus.LOADING);
    };
    this.handleLoadEnd = () => {
      this.props.onStatusChange(PlayerStatus.READY);
    };
    this.handlePlay = () => {
      this.props.onStatusChange(PlayerStatus.PLAYING);
    };
    this.handlePause = () => {
      this.props.onStatusChange(PlayerStatus.PAUSED);
    };
    this.handleComplete = () => {
      this.props.onStatusChange(PlayerStatus.ENDED);
    };
    this.handleClickEditorPreview = () => {
      this.props.onClickPoster();
    };
  }
  componentDidMount() {
    this.props.onStatusChange(PlayerStatus.READY);
  }
  componentDidUpdate(prevProps) {
    const {
      currentTime
    } = this.props;
    if (this.videoEl.current && typeof currentTime === 'number' && currentTime !== prevProps.currentTime) {
      this.videoEl.current.currentTime = this.props.currentTime;
    }
  }
  render() {
    const {
      video,
      options,
      playerType
    } = this.props;
    if (playerType === PlayerTypes.RICH_TEXT_PREVIEW || playerType === PlayerTypes.EDITOR_PREVIEW) {
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsxs("div", {
          className: "video-js vjs-hubspot vjs-fill",
          onClick: this.handleClickEditorPreview,
          children: [/*#__PURE__*/_jsx("img", {
            className: "rich-text-preview",
            alt: video.altText || video.title,
            src: video.posterUrl,
            style: {
              position: 'absolute',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: this.state.imgLoadFailed ? 'none' : 'block'
            },
            onError: () => this.setState({
              imgLoadFailed: true
            })
          }), /*#__PURE__*/_jsx(SimplePlayButton, {
            backgroundColor: options.playButtonColor
          }), /*#__PURE__*/_jsx(NavMarker, {
            name: "PLAYER_LOADED"
          })]
        })
      );
    }
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsxs("div", {
        className: "video-js vjs-hubspot vjs-fill",
        children: [/*#__PURE__*/_jsx(SimpleVideoPlayer, {
          ref: this.videoEl,
          className: "vjs-tech",
          src: video.fileUrl,
          controls: !options.hiddenControls,
          autoPlay: options.autoplay,
          muted: options.muted,
          loop: options.loop,
          posterUrl: video.posterUrl,
          title: video.altText || video.title,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleComplete,
          onLoadStart: this.handleLoading,
          onLoadedData: this.handleLoadEnd
        }), /*#__PURE__*/_jsx(SimplePlayButton, {
          backgroundColor: options.playButtonColor,
          onClick: () => {
            if (this.videoEl.current) {
              this.videoEl.current.play().catch(error => {
                throw error;
              });
            }
          }
        }), /*#__PURE__*/_jsx(NavMarker, {
          name: "PLAYER_LOADED"
        })]
      })
    );
  }
}
StaticPosterImage.defaultProps = {
  onStatusChange: () => {},
  onClickPoster: () => {}
};